const PREFIX = '[IMPORTANT DATES]';

export const SHOW_ALL_FORECOMING_EVENTS = `${PREFIX} SHOW_ALL_FORECOMING_EVENTS`;
export const SHOW_EXPIRED_EVENTS = `${PREFIX} SHOW_EXPIRED_EVENTS`;
export const RESET = `${PREFIX} RESET`;

export const showAllForecomingEvents = () => ({
  type: SHOW_ALL_FORECOMING_EVENTS,
});

export const showExpiredEvents = () => ({
  type: SHOW_EXPIRED_EVENTS,
});

export const resetState = () => ({
  type: RESET,
});



// WEBPACK FOOTER //
// ./src/store/actions/importantDates.js